import type { ReactNode } from "react";

import type { Permission } from "@/api/permissions";
import { useHasPermission } from "@/auth/use-whoami";

/**
 * Renders children only when the signed-in admin holds the permission.
 * UX only — the backend enforces the same permission on every endpoint.
 */
export function Can({
  permission,
  fallback = null,
  children,
}: {
  permission: Permission;
  fallback?: ReactNode;
  children: ReactNode;
}) {
  const hasPermission = useHasPermission();
  return <>{hasPermission(permission) ? children : fallback}</>;
}
